// Copyright (c) StrangeBee 2023

import { classList } from '@Helpers/className';
import { DefaultOptionType, SelectProps, SelectValue } from 'antd/lib/select';
import React, { ReactElement } from 'react';
import { THSelect } from '../THSelect/THSelect';

import './THBaseSelector.scss';

interface THBaseSelectorProps<T extends SelectValue> extends SelectProps<T> {
    options?: DefaultOptionType[];
    borderless?: boolean;
}

export const THBaseSelector = <T extends SelectValue>({
    options = [],
    className,
    allowClear = true,
    borderless = true,
    ...props
}: THBaseSelectorProps<T>): ReactElement => {
    return (
        <THSelect
            allowClear={allowClear}
            borderless={borderless}
            showSearch
            className={classList('select-base', className, { 'empty-value': props.value === undefined })}
            filterOption={(inputValue, option) => {
                const label = (option?.label as any).props.label || '';
                const value = option?.value + '' || '';

                return (
                    label.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1 ||
                    value.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1
                );
            }}
            options={options}
            {...props}
        />
    );
};
